'use strict';

var util = angular.module('gymsystem.util');

util.controller('BankgiroAdminCtrl', ['$scope', 'server', 'live', '$http', 'alertProvider', 'fileManager', '$q',
        function($scope, server, live, $http, alertProvider, fileManager, $q) {

    $scope.mode = '';
    $scope.setMode = function(mode) {
        $scope.mode = mode;
    };

    function dateToString(date) {
        return date?date.yyyymmdd() + ' ' + date.hhmm():'';
    }

    var fileElement;

    function upload(file) {
        var fd = new FormData();
        fd.append('file', file);

        $http.post('/api/admin/bankgiro/upload', fd, {
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined}
        }).success(function() {
            fileElement.value = '';
            alertProvider.show('success', 'Success');
            $scope.fileLoading = false;
        }).error(function () {
            fileElement.value = '';
            alertProvider.show('error', 'Fail');
            $scope.fileLoading = false;
        });
        $scope.fileLoading = true;
    }

    function fileChosen() {
        var files = fileElement.files;
        if(!files) {return;}
        $scope.$apply(function() {
            for(var i=0;i<files.length;i++) {
                upload(files[i]);
            }
        });
    }

    $scope.initFileElement = function(el) {
        fileElement = el;
        el.addEventListener('change', fileChosen);
        $scope.$on('$destroy', function() {
            el.removeEventListener('change', fileChosen);
        });
    };

    var ddfiles = [];  // Direct-Debit files
    $scope.ddfilesControl = {};
    $scope.ddfilesConfig = {
        getItems: function() {
            return ddfiles;
        },
        //rowClass: function(file) {},
        headerClass: 'glyphicon glyphicon-credit-card',
        hideSearch: true,
        columns: [
            {
                field: 'name',
                title: 'Name',
                getValue: function(file) {
                    return file.filename;
                }
            },
            {
                field: 'created',
                title: 'Created',
                getValue: function(file) {
                    return file.created.slice(0, 10);
                }
            },
            {field: 'size', title: 'Size', getValue: function(file) {return fileManager.decorateSize(file.data.length);}}
        ],
        buttons: [
            {
                title: 'Upload file',
                buttonClass: 'btn-warning',
                //visible: function(file) {},
                onClick: function(file) {
                    $http.post('/api/admin/bankgiro/upload?fileid='+file.id).success(function() {
                        alertProvider.show('success', 'Success');
                    }).error(function () {
                        alertProvider.show('error', 'Fail');
                    });
                },
                tooltip: 'Upload'
            }
        ]
    };

    server.get('/api/directdebit/files/get').then(function(result) {
        ddfiles = result.sort(function(a, b) {
            if(a.created < b.created) {return 1;}
            if(a.created > b.created) {return -1;}
            return 0;
        });
        return $scope.ddfilesControl.update && $scope.ddfilesControl.update();
    });

    // Inbox
    $scope.inboxLogs = '';
    function fetchLogs(controlKey) {
        var deferred = $q.defer();
        var timeout = setTimeout(function() {
            deferred.reject();
        }, 20000);

        var unsubscribe = live.subscribe({
            type: 'staff_event',
            scope: $scope,
            action: controlKey,
            callback: function(msg) {
                var data = msg.data;
                if(data.log) {
                    $scope.inboxLogs += data.log + '\n';
                    $scope.$apply();
                    if(timeout) {
                        clearTimeout(timeout);
                        timeout = null;
                    }
                }
                if(data.final) {
                    unsubscribe();
                    deferred.resolve();
                }
            }
        });
        return deferred.promise;
    }

    var inbox = [];
    var filesInLoading = {};
    $scope.inboxControl = {};
    $scope.inboxConfig = {
        idKey: 'filename',
        getItems: function() {
            return inbox;
        },
        rowClass: function(file) {
            if(file.error) {return 'error';}
            if(file.downloaded) {return '';}
            return 'downloaded';
        },
        rowClick: function(file) {
            if(file.logs) {
                alertProvider.modal(file.name, file.logs, {pre: true});
            }
        },
        headerClass: 'glyphicon glyphicon-credit-card',
        hideSearch: true,
        columns: [
            {
                field: 'name',
                title: 'Name',
                getValue: function(file) {
                    return file.filename;
                }
            },
            {
                field: 'created',
                title: 'Created',
                getValue: function(file) {
                    return dateToString(file.created);
                }
            },
            {
                field: 'downloaded',
                title: 'Downloaded',
                getValue: function(file) {
                    return dateToString(file.downloaded);
                }
            },
            {
                field: 'bankgiro_number',
                title: 'Bankgiro number',
                getValue: function(file) {
                    return file.bankgiro_number || '';
                }
            },
            {
                field: 'company_name',
                title: 'Company name',
                getValue: function(file) {
                    return file.company_name || '';
                }
            },
            {field: 'size', title: 'Size', getValue: function(file) {return fileManager.decorateSize(file.size);}}
        ],
        buttons: [
            {
                title: 'Download',
                buttonClass: 'btn-warning',
                onClick: function(file) {
                    fileManager.downloadFileByUrl('/api/admin/bankgiro/get_file?filename='+file.filename);
                    if(!file.downloaded) {
                        file.downloaded = new Date();
                        $scope.inboxControl.update();
                    }
                },
                tooltip: 'Download'
            },
            {
                title: 'Process',
                onClick: function(file) {
                    filesInLoading[file.filename] = true;

                    function doSuccess() {
                        alertProvider.show('success', 'Success');
                        filesInLoading[file.filename] = false;
                    }
                    function doFail() {
                        alertProvider.show('error', 'Fail');
                        filesInLoading[file.filename] = false;
                    }

                    server.post2('/api/admin/bankgiro/process', {
                        filename: file.filename
                    }).then(function(response) {
                        if(response && response.control_key) {
                            fetchLogs(response.control_key).then(doSuccess, doFail);
                        } else {
                            doSuccess();
                        }
                    }, doFail);
                },
                tooltip: 'Process',
                loading: function(file) {
                    return filesInLoading[file.filename];
                }
            }
        ]
    };

    function reloadInbox() {
        server.post2('/api/admin/bankgiro/get_inbox').then(function(result) {
            inbox = result;
            return $scope.inboxControl.update && $scope.inboxControl.update();
        });
    }

    reloadInbox();

}]);